var resizeObservers = [];
export { resizeObservers };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js
// module id = null
// module chunks = 